export default "__VITE_ASSET__CyRpgjwN__"